import { ModalGallery } from '@components'
import type { GalleryItem } from './interfaces/gallery-item'

export class Gallery {
  /** Контроллер модального окна просмотра галереи */
  private readonly modal: ModalGallery
  /** Контейнер галереи */
  private readonly container: HTMLElement
  /** базовый путь к папкам галерей src/assets/images/gallery/ */
  private readonly pathBase: string
  /** путь к папке текущей галереи */
  private readonly galleryPath: string
  /** Название галереи */
  private readonly galleryTitle: string
  /** массив имен картинок */
  private readonly imageNames: string[] = []
  /** количество картинок */
  public get length() {
    return this.imageNames.length
  }

  /**
   * @param container Контейнер галереи
   * @param modal Контроллер модального окна просмотра галереи
   */
  constructor(container: HTMLElement, modal: ModalGallery) {
    this.modal = modal
    this.container = container
    this.pathBase = this.container.dataset.pathBase!
    this.galleryTitle = this.container.dataset.title!
    this.galleryPath = this.pathBase + this.galleryTitle
    const images = [...container.querySelectorAll<HTMLImageElement>('.gallery_image')]
    this.imageNames = images.map(image => image.src.split('/').pop()!)
    this.container.addEventListener('click', this.clickHandler.bind(this))
  }

  /** Обработчик клика по картинке в мини-галерее */
  private clickHandler(event: Event) {
    const button = (event.target as Element).closest<HTMLButtonElement>('.gallery_link')
    if (!button || !button.dataset.index) return
    const index = Number(button.dataset.index)
    this.openModal(index)
  }

  /** Открытие <dialog> под управлением ModalGallery 
   *  Открытие картинки по номеру
  */
  private openModal(index: number) {
    this.modal.open(this, index)
  }

  /** получить объект с информацией о картинке */
  public getItem(index: number): GalleryItem {
    const name = this.imageNames[index]
    if (!name) throw new RangeError(`Картинки с индексом ${index} нету`)
    return {
      src: this.galleryPath + '/full-res/' + name,
      thumb: this.galleryPath + '/sm/' + name,
      title: name.split('.').at(0)!
    }
  }
}
